export const navigationLinks = (t: (key: string) => string) => [
  { label: t('tariff'), link: '/' },
  { label: t('offerCalculator'), link: '' },
  { label: t('aboutUs'), link: '/about' },
  { label: t('faq'), link: '/faq' },
];
